import { StreamActions } from "@hotwired/turbo"

StreamActions.redirect = function() {
    let frame = this.getAttribute("frame") || "_top";
    let url = this.getAttribute("url");
    Turbo.visit(url, { frame: frame });
};
